import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "honorRollCheckbox", "honorRollThreshold",
    "cmSignatureSection", "hrSignatureSection",
    "rcSignatureDetails", "cmSignatureDetails", "hrSignatureDetails"
  ]

  connect() {
    console.log('=== ReportCardFormController: connect() called ===')
    console.log('Controller element:', this.element)
    console.log('initSlimSelects available:', typeof window.initSlimSelects)
    
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(() => {
      console.log('=== ReportCardFormController: Initial updateVisibility() call ===')
      this.updateVisibility()
      // Initialize honor roll threshold visibility
      this.toggleHonorRollThreshold()
    }, 100)
  }
  
  onPeriodTypeChange(event) {
    console.log('=== ReportCardFormController: onPeriodTypeChange() called ===')
    console.log('Event:', event)
    console.log('Event target:', event.target)
    console.log('Event target value:', event.target?.value)
    console.log('Event target name:', event.target?.name)
    
    // Also check all radio buttons - try both possible name formats
    const allRadioButtons1 = document.querySelectorAll('input[name="report_card[period_type]"]')
    const allRadioButtons2 = document.querySelectorAll('input[name="report_card_generator[period_type]"]')
    const allRadioButtons = allRadioButtons1.length > 0 ? allRadioButtons1 : allRadioButtons2
    console.log('All period_type radio buttons found (report_card):', allRadioButtons1.length)
    console.log('All period_type radio buttons found (report_card_generator):', allRadioButtons2.length)
    allRadioButtons.forEach((rb, index) => {
      console.log(`Radio button ${index}: value="${rb.value}", checked=${rb.checked}, name="${rb.name}"`)
    })
    
    // Pass the selected value directly to updateVisibility
    const selectedPeriodType = event.target?.value
    console.log('Selected period type from event:', selectedPeriodType)
    this.updateVisibility(selectedPeriodType)
  }
  
  onAcademicYearChange(event) {
    console.log('=== ReportCardFormController: onAcademicYearChange() called ===')
    const academicYearId = event.target.value
    console.log('Academic year ID:', academicYearId)
    if (academicYearId) {
      this.fetchPedagogicMonths(academicYearId)
    }
  }
  
  updateVisibility(forcedPeriodType = null) {
    console.log('=== ReportCardFormController: updateVisibility() called ===')
    console.log('forcedPeriodType parameter:', forcedPeriodType)
    
    // Find the checked radio button - try both possible name formats
    let checkedRadio = document.querySelector('input[name="report_card[period_type]"]:checked')
    if (!checkedRadio) {
      checkedRadio = document.querySelector('input[name="report_card_generator[period_type]"]:checked')
    }
    console.log('Checked radio button (report_card):', document.querySelector('input[name="report_card[period_type]"]:checked'))
    console.log('Checked radio button (report_card_generator):', document.querySelector('input[name="report_card_generator[period_type]"]:checked'))
    console.log('Checked radio button (final):', checkedRadio)
    console.log('Checked radio button value:', checkedRadio?.value)
    console.log('Checked radio button name:', checkedRadio?.name)
    
    // Use forcedPeriodType if provided, otherwise try to get from checked radio, otherwise default to 'trimester'
    const periodType = forcedPeriodType || checkedRadio?.value || 'trimester'
    console.log('Determined periodType:', periodType, '(forcedPeriodType:', forcedPeriodType, ', checkedRadio?.value:', checkedRadio?.value, ')')
    
    // Find the selection containers
    const trimesterSelection = document.getElementById('trimester_selection')
    const pedagogicMonthSelection = document.getElementById('pedagogic_month_selection')

    // The annual report card (DU VAAL, 07/10/2026) takes no period: both
    // period fields hide and stop being required.
    const annualSelection = document.getElementById('annual_selection')
    const annual = periodType === 'annual'
    if (annualSelection) annualSelection.style.display = annual ? 'block' : 'none'
    ;[trimesterSelection, pedagogicMonthSelection].forEach((container) => {
      container?.querySelectorAll('select').forEach((select) => {
        if (annual && select.required) {
          select.dataset.annualRequired = 'true'
          select.required = false
        } else if (!annual && select.dataset.annualRequired) {
          select.required = true
          delete select.dataset.annualRequired
        }
      })
    })
    if (annual) {
      if (trimesterSelection) trimesterSelection.style.display = 'none'
      if (pedagogicMonthSelection) pedagogicMonthSelection.style.display = 'none'
      return
    }
    
    console.log('trimester_selection element found:', !!trimesterSelection)
    console.log('pedagogic_month_selection element found:', !!pedagogicMonthSelection)
    
    if (trimesterSelection) {
      console.log('trimester_selection current style:', trimesterSelection.style.cssText)
      console.log('trimester_selection current display:', window.getComputedStyle(trimesterSelection).display)
    }
    
    if (pedagogicMonthSelection) {
      console.log('pedagogic_month_selection current style:', pedagogicMonthSelection.style.cssText)
      console.log('pedagogic_month_selection current display:', window.getComputedStyle(pedagogicMonthSelection).display)
      console.log('pedagogic_month_selection innerHTML length:', pedagogicMonthSelection.innerHTML?.length)
    }
    
    if (periodType === 'pedagogical_month') {
      console.log('--- Setting visibility for pedagogical_month period type ---')
      
      if (trimesterSelection) {
        console.log('Hiding trimester_selection')
        trimesterSelection.removeAttribute('style')
        trimesterSelection.style.display = 'none'
        console.log('trimester_selection style after change:', trimesterSelection.style.cssText)
        console.log('trimester_selection computed display after change:', window.getComputedStyle(trimesterSelection).display)
      } else {
        console.warn('trimester_selection element not found!')
      }
      
      if (pedagogicMonthSelection) {
        console.log('Showing pedagogic_month_selection')
        pedagogicMonthSelection.removeAttribute('style')
        pedagogicMonthSelection.style.display = 'block'
        console.log('pedagogic_month_selection style after change:', pedagogicMonthSelection.style.cssText)
        console.log('pedagogic_month_selection computed display after change:', window.getComputedStyle(pedagogicMonthSelection).display)
        
        // Reinitialize SlimSelect for the pedagogic month select if it exists
        console.log('--- Looking for pedagogic month select element ---')
        
        // Try multiple ways to find the select
        let pedagogicMonthSelect = pedagogicMonthSelection.querySelector('select[id*="pedagogic_month_id"]')
        console.log('Trying querySelector select[id*="pedagogic_month_id"]:', !!pedagogicMonthSelect)
        
        if (!pedagogicMonthSelect) {
          pedagogicMonthSelect = document.getElementById('report_card_generator_pedagogic_month_id')
          console.log('Trying getElementById report_card_generator_pedagogic_month_id:', !!pedagogicMonthSelect)
        }
        
        if (!pedagogicMonthSelect) {
          pedagogicMonthSelect = document.getElementById('report_card_pedagogic_month_id')
          console.log('Trying getElementById report_card_pedagogic_month_id:', !!pedagogicMonthSelect)
        }
        
        if (!pedagogicMonthSelect) {
          pedagogicMonthSelect = pedagogicMonthSelection.querySelector('select')
          console.log('Trying querySelector select (any):', !!pedagogicMonthSelect)
        }
        
        // Log all selects in the container
        const allSelects = pedagogicMonthSelection.querySelectorAll('select')
        console.log('All select elements in pedagogic_month_selection:', allSelects.length)
        allSelects.forEach((sel, index) => {
          console.log(`Select ${index}: id="${sel.id}", name="${sel.name}"`)
        })
        
        if (pedagogicMonthSelect && window.initSlimSelects) {
          console.log('--- Found pedagogic month select, reinitializing SlimSelect ---')
          console.log('Select element:', pedagogicMonthSelect)
          console.log('Select ID:', pedagogicMonthSelect.id)
          console.log('Select name:', pedagogicMonthSelect.name)
          console.log('Select current display:', window.getComputedStyle(pedagogicMonthSelect).display)
          
          // Destroy existing SlimSelect instance if it exists
          if (pedagogicMonthSelect.slim) {
            console.log('Existing SlimSelect instance found, destroying...')
            try {
              pedagogicMonthSelect.slim.destroy()
              console.log('✓ Destroyed existing SlimSelect instance')
            } catch (e) {
              console.error('✗ Error destroying SlimSelect:', e)
            }
          } else {
            console.log('No existing SlimSelect instance found')
          }
          
          // Remove SlimSelect wrapper if it exists (could be next sibling or in parent)
          const slimSelectWrapper = pedagogicMonthSelect.nextElementSibling ||
                                   pedagogicMonthSelect.parentNode?.querySelector('.ss-main')
          console.log('SlimSelect wrapper found:', !!slimSelectWrapper)
          if (slimSelectWrapper && slimSelectWrapper.classList.contains('ss-main')) {
            console.log('Removing SlimSelect wrapper...')
            slimSelectWrapper.remove()
            console.log('✓ Removed SlimSelect wrapper')
          }
          
          // Reset data attribute and display
          pedagogicMonthSelect.removeAttribute('data-slim-initialized')
          pedagogicMonthSelect.style.display = ''
          console.log('Reset select attributes and display')
          
          // Reinitialize SlimSelect after a small delay to ensure DOM is ready
          setTimeout(() => {
            console.log('--- Reinitializing SlimSelect for pedagogic month ---')
            console.log('initSlimSelects function:', typeof window.initSlimSelects)
            try {
              window.initSlimSelects(pedagogicMonthSelect)
              console.log('✓ SlimSelect reinitialized successfully')
              
              // Verify it worked
              setTimeout(() => {
                const wrapper = pedagogicMonthSelect.parentNode?.querySelector('.ss-main')
                console.log('SlimSelect wrapper after initialization:', !!wrapper)
                if (wrapper) {
                  console.log('Wrapper display:', window.getComputedStyle(wrapper).display)
                }
              }, 50)
            } catch (e) {
              console.error('✗ Error reinitializing SlimSelect:', e)
            }
          }, 100)
        } else {
          console.warn('--- Could not reinitialize SlimSelect ---')
          console.warn('pedagogicMonthSelect found:', !!pedagogicMonthSelect)
          console.warn('window.initSlimSelects available:', typeof window.initSlimSelects)
        }
      } else {
        console.error('✗ pedagogic_month_selection element not found!')
      }
    } else {
      console.log('--- Setting visibility for trimester period type ---')
      
      if (trimesterSelection) {
        console.log('Showing trimester_selection')
        trimesterSelection.removeAttribute('style')
        trimesterSelection.style.display = 'block'
        console.log('trimester_selection computed display after change:', window.getComputedStyle(trimesterSelection).display)
      }
      
      if (pedagogicMonthSelection) {
        console.log('Hiding pedagogic_month_selection')
        pedagogicMonthSelection.removeAttribute('style')
        pedagogicMonthSelection.style.display = 'none'
        console.log('pedagogic_month_selection computed display after change:', window.getComputedStyle(pedagogicMonthSelection).display)
      }
    }
    
    console.log('=== updateVisibility() completed ===')
  }
  
  async fetchPedagogicMonths(academicYearId) {
    console.log('=== ReportCardFormController: fetchPedagogicMonths() called ===')
    console.log('Academic year ID:', academicYearId)
    try {
      const url = `/schools/docs/report_cards/get_pedagogic_months?academic_year_id=${academicYearId}`
      console.log('Fetching URL:', url)
      const response = await fetch(url)
      console.log('Response status:', response.status)
      const data = await response.json()
      console.log('Response data:', data)
      console.log('Pedagogic months received:', data.pedagogic_months?.length || 0)
      this.updatePedagogicMonthOptions(data.pedagogic_months || [])
    } catch (error) {
      console.error('✗ Error fetching pedagogic months:', error)
      console.error('Error stack:', error.stack)
    }
  }
  
  updatePedagogicMonthOptions(months) {
    console.log('=== ReportCardFormController: updatePedagogicMonthOptions() called ===')
    console.log('Months to add:', months.length)
    console.log('Months data:', months)
    
    const pedagogicMonthSelection = document.getElementById('pedagogic_month_selection')
    if (!pedagogicMonthSelection) {
      console.error('✗ pedagogic_month_selection element not found!')
      return
    }
    console.log('✓ Found pedagogic_month_selection element')
    
    const select = pedagogicMonthSelection.querySelector('select')
    if (!select) {
      console.error('✗ Select element not found inside pedagogic_month_selection!')
      return
    }
    console.log('✓ Found select element:', select.id)
    console.log('Current options count:', select.options.length)
    
    // Clear existing options except the first (blank)
    while (select.options.length > 1) {
      select.remove(1)
    }
    console.log('Cleared existing options, remaining options:', select.options.length)
    
    // Add new options
    months.forEach((month, index) => {
      const option = document.createElement('option')
      option.value = month.id
      option.textContent = month.name_with_dates || month.name
      select.appendChild(option)
      console.log(`Added option ${index + 1}: value="${month.id}", text="${option.textContent}"`)
    })
    
    console.log('Final options count:', select.options.length)
    
    // If SlimSelect is already initialized, we need to update it
    if (select.slim) {
      console.log('SlimSelect instance found, updating...')
      try {
        select.slim.setData(months.map(m => ({ text: m.name_with_dates || m.name, value: m.id.toString() })))
        console.log('✓ SlimSelect data updated')
      } catch (e) {
        console.error('✗ Error updating SlimSelect data:', e)
      }
    } else {
      console.log('No SlimSelect instance found, will be initialized when element becomes visible')
    }
  }

  toggleDocSignature(event) {
    const prefix = event.params.prefix
    const isChecked = event.target.checked
    const targetName = `${prefix}SignatureDetails`

    if (this[`has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`]) {
      this[`${targetName}Target`].style.display = isChecked ? 'block' : 'none'
    } else {
      // Fallback: find by ID
      const details = document.getElementById(`${prefix}_signature_details`)
      if (details) {
        details.style.display = isChecked ? 'block' : 'none'
      }
    }
  }

  toggleCouncilMinutes(event) {
    const isChecked = event.target.checked
    if (this.hasCmSignatureSectionTarget) {
      this.cmSignatureSectionTarget.style.display = isChecked ? 'block' : 'none'
    } else {
      const section = document.getElementById('cm_signature_section')
      if (section) {
        section.style.display = isChecked ? 'block' : 'none'
      }
    }
  }

  toggleHonorRollThreshold(event = null) {
    console.log('=== ReportCardFormController: toggleHonorRollThreshold() called ===')
    
    // Get checkbox state - either from event or from target
    let isChecked = false
    if (event) {
      isChecked = event.target.checked
      console.log('Checkbox state from event:', isChecked)
    } else if (this.hasHonorRollCheckboxTarget) {
      isChecked = this.honorRollCheckboxTarget.checked
      console.log('Checkbox state from target:', isChecked)
    } else {
      // Try to find checkbox manually
      const checkbox = document.querySelector('input[name*="include_honor_roll"]:checked') || 
                       document.querySelector('input[name*="include_honor_roll"]')
      if (checkbox) {
        isChecked = checkbox.checked
        console.log('Checkbox state from manual query:', isChecked)
      }
    }
    
    // Show/hide threshold field
    if (this.hasHonorRollThresholdTarget) {
      if (isChecked) {
        this.honorRollThresholdTarget.style.display = 'block'
        console.log('Showing honor roll threshold field')
      } else {
        this.honorRollThresholdTarget.style.display = 'none'
        console.log('Hiding honor roll threshold field')
      }
    } else {
      // Fallback: try to find by ID
      const thresholdContainer = document.getElementById('honor_roll_threshold_container')
      if (thresholdContainer) {
        thresholdContainer.style.display = isChecked ? 'block' : 'none'
        console.log('Toggled threshold container via ID:', isChecked)
      } else {
        console.warn('Honor roll threshold target not found')
      }
    }

    // Also toggle HR signature section
    if (this.hasHrSignatureSectionTarget) {
      this.hrSignatureSectionTarget.style.display = isChecked ? 'block' : 'none'
    } else {
      const hrSection = document.getElementById('hr_signature_section')
      if (hrSection) {
        hrSection.style.display = isChecked ? 'block' : 'none'
      }
    }
  }
}

